import React, { useContext, useEffect, useState } from 'react';
import { View, Text, Image, useWindowDimensions } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { RectButton, ScrollView } from 'react-native-gesture-handler';
import { useNavigation } from '@react-navigation/native';

import cathecismLogo from '../../assets/images/cathecism-icon.png';
import ProgressBar from '../../components/ProgressBar';
import styles from './styles';
import AsyncStorage from '@react-native-async-storage/async-storage';

import { AppContext } from '../../Context/AppContext';
import Loading from '../../components/Loading';
import { SafeAreaView } from 'react-native-safe-area-context';

const Home: React.FC = () => {
  const [loaded, setLoaded] = useState(false);
  const [percentage, setPercentage] = useState(0);
  const maxParagraphs = 2865;
  const width = useWindowDimensions().width < 500 ? '100%' : 500;

  const {
    bookmark,
    setBookmark,
    saveBookmark,
    getBookmark,
  } = useContext(AppContext);

  const { navigate } = useNavigation();

  function handleGoToSections() {
    navigate("Sections");
  }

  function redirectToReading() {
    if (bookmark) {
      navigate('Reading', {
        partIndex: bookmark.partIndex,
        sectionIndex: bookmark.sectionIndex,
        comeFromHome: true,
      })
    } else {
      navigate('Reading', {
        partIndex: 0,
        sectionIndex: 0,
        comeFromHome: true
      })
    }
  }

  useEffect(() => {
    (async () => {
      const response = await getBookmark();

      setBookmark(response);
      setLoaded(true);
    })();
  }, []);

  useEffect(() => {
    if (bookmark) {
      const formatedPercentage = Math.round((bookmark.paragraphNumber * 100) / maxParagraphs);
      setPercentage(formatedPercentage);
    }
  }, [bookmark]);

  if (!loaded) {
    return <Loading />
  }

  return (
    <SafeAreaView 
      style={[
        styles.mainContainer,
      ]}
    >
      <View
        style={{
          width,
        }}
      
      >
        <View style={styles.header}>
          <Image 
            source={cathecismLogo} 
            style={styles.headerLogo}
          />
          <Text style={styles.headerTitle}>
            Catecismo da Igreja Católica
          </Text>
        </View>

        <ProgressBar percentage={percentage} />

        <ScrollView contentContainerStyle={styles.items}>
          <View style={styles.itemContainer}>
            <Text style={styles.itemText}>
              {
                bookmark
                ? `Continuar a leitura ${bookmark.sectionName}`
                : 'Iniciar a leitura do Catecismo'
              }
            </Text>
            <RectButton 
              style={
                [
                  styles.itemButton,
                  {
                    backgroundColor: '#4DD66F'
                  }
                ]
              }

              onPress={redirectToReading}
            >
              <View accessible>
                <Feather 
                  name="arrow-right" 
                  size={40}
                  style={{
                    color: 'white',
                  }}
                />
              </View>
            </RectButton>
          </View>

          <View style={styles.itemContainer}>
            <Text style={styles.itemText}>Seções</Text>
            <RectButton 
              style={[
                styles.itemButton,
                {
                  backgroundColor: '#F0784A'
                }
              ]} 
              onPress={handleGoToSections}
            >
              <View accessible>
                <Feather 
                  name="book-open"
                  size={40}
                  style={{
                    color: 'white',
                  }}
                />
              </View>
            </RectButton>
          </View>

          {/* <View style={styles.itemContainer}>
            <Text style={styles.itemText}>Favoritos</Text>
            <RectButton style={
              [
                styles.itemButton,
                {
                  backgroundColor: '#FCD44E'
                }
              ]
            }
            >
              <View accessible>
                <Feather 
                  name="star"
                  size={40}
                  style={{
                    color: 'black',
                  }}
                />
              </View>
            </RectButton>
          </View> */}
          <View style={styles.itemContainer}>
            <Text style={styles.itemText}>Sobre o app</Text>
            <RectButton style={
              [
                styles.itemButton,
                {
                  backgroundColor: '#32A9F0'
                }
              ]
            }
            onPress={() => navigate('About')}
            >
              <View accessible>
                <Feather 
                  name="info"
                  size={40}
                  style={{
                    color: 'white',
                  }}
                />
              </View>
            </RectButton>
          </View>
        </ScrollView>
      </View>
    </SafeAreaView>
  );
};

export default Home;